import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import ActiveWorkoutSession from '@/components/workouts/ActiveWorkoutSession'
import { requirePermission } from '@/lib/permissions/permissions'
import { store } from '@/lib/states/store'
import { useWorkoutSession } from '@/lib/states/workout/hooks'

export const Route = createFileRoute('/_auth/workout-session')({
  beforeLoad: ({ context }) => {
    if (!context.session) {
      store.getState().session.reset()
      throw redirect({
        to: '/login',
        replace: true,
      })
    }

    const org = store.getState().session.org
    if (!org) {
      throw Error('No Org')
    }

    if (!org.setupComplete) {
      throw redirect({
        to: '/setup',
        replace: true,
      })
    }

    requirePermission('workouts.write')

    const activeWorkout = store.getState().workoutSession.activeWorkoutData
    if (!activeWorkout?.clientId) {
      throw redirect({
        to: '/clients',
        replace: true,
      })
    }

    return { session: context.session }
  },
  pendingMs: 200,
  component: WorkoutSessionRoute,
})

function WorkoutSessionRoute() {
  const { activeWorkoutData, setMinimized } = useWorkoutSession()

  useEffect(() => {
    setMinimized(false)
  }, [setMinimized])

  if (!activeWorkoutData?.clientId) {
    return null
  }

  return (
    <ActiveWorkoutSession clientId={activeWorkoutData.clientId} />
  )
}
